import { render, staticRenderFns } from "./DesignatedDoctorUserFilter.vue?vue&type=template&id=40a9f490&scoped=true&"
import script from "./DesignatedDoctorUserFilter.vue?vue&type=script&lang=ts&"
export * from "./DesignatedDoctorUserFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9f490",
  null
  
)

export default component.exports